import { createFeature, createReducer, on } from '@ngrx/store';

import { AuthActions } from '../../auth/store';
import { DashboardActions } from './dashboard.actions';
import { initialDashboardState } from './dashboard.state';

export const dashboardFeature = createFeature({
  name: 'dashboard',
  reducer: createReducer(
    initialDashboardState,
    on(
      AuthActions.verifyOtpSuccess,
      AuthActions.logout,
      AuthActions.logoutSuccess,
      () => initialDashboardState,
    ),
    on(DashboardActions.selectLayout, (state, { layout }) => ({
      ...state,
      layout,
    })),
    on(DashboardActions.loadOverview, (state) => ({
      ...state,
      overview: null,
      overviewLoading: true,
      overviewError: null,
    })),
    on(DashboardActions.loadOverviewSuccess, (state, { overview }) => ({
      ...state,
      overview,
      overviewLoading: false,
      overviewError: null,
    })),
    on(DashboardActions.loadOverviewFailure, (state, { error }) => ({
      ...state,
      overviewLoading: false,
      overviewError: error,
    })),
    on(DashboardActions.refreshOperationalOverview, (state) => ({
      ...state,
      overviewLoading: true,
      overviewError: null,
    })),
    on(DashboardActions.refreshOperationalOverviewSuccess, (state, { overview }) => ({
      ...state,
      overview: state.overview
        ? {
            ...state.overview,
            ...overview,
          }
        : overview,
      overviewLoading: false,
      overviewError: null,
    })),
    on(DashboardActions.refreshOperationalOverviewFailure, (state, { error }) => ({
      ...state,
      overviewLoading: false,
      overviewError: error,
    })),
    on(DashboardActions.refreshPartnersOverviewSuccess, (state, { partners }) => ({
      ...state,
      overview: state.overview
        ? {
            ...state.overview,
            partners,
          }
        : state.overview,
    })),
    on(DashboardActions.loadPartnerTracking, (state) => ({
      ...state,
      trackingLoading: true,
      trackingError: null,
    })),
    on(DashboardActions.loadPartnerTrackingSuccess, (state, { tracking }) => ({
      ...state,
      tracking,
      trackingLoading: false,
      trackingError: null,
    })),
    on(DashboardActions.loadPartnerTrackingFailure, (state, { error }) => ({
      ...state,
      trackingLoading: false,
      trackingError: error,
    })),
  ),
});

export const {
  name: dashboardFeatureKey,
  reducer: dashboardReducer,
  selectOverview,
  selectTracking,
  selectOverviewLoading,
  selectTrackingLoading,
  selectOverviewError,
  selectTrackingError,
  selectLayout,
} = dashboardFeature;
